// extracted by mini-css-extract-plugin
export var col = "fc-two-up-media-module--col--ab85b";
export var colLarge = "fc-two-up-media-module--colLarge--f11ec";
export var colSmall = "fc-two-up-media-module--colSmall--7d94e";
export var copy = "fc-two-up-media-module--copy--e9dd5";
export var media = "fc-two-up-media-module--media--5dc24";
export var root = "fc-two-up-media-module--root--e4f81";
export var rowMedia = "fc-two-up-media-module--rowMedia--e3348";
export var rowText = "fc-two-up-media-module--rowText--3a007";
export var switchSide = "fc-two-up-media-module--switchSide--bd170";
export var text = "fc-two-up-media-module--text--d7380";
export var textPositionTop = "fc-two-up-media-module--textPositionTop--d6aa1";
export var title = "fc-two-up-media-module--title--29f10";